module.exports = __webpack_public_path__ + "img/icon_about_company.e7182bcc.png";